import { ComposeTemplateMetadata } from 'types/Compose'

export const kJournals: ComposeTemplateMetadata[] = [
  {
    templateId: 'morning-intention',
    name: 'Morning\nIntention',
    category: 'Daily',
    description:
      'Set your day up for success by approaching it with intention.',
    minutes: 5,
    timeofDayRange: [4, 12],
    tags: ['Check-in'],
    weight: -50,
  },
  {
    templateId: 'gratitude',
    name: 'Gratitude\nJournal',
    category: 'Daily',
    description: "Take a moment to connect with what you're grateful for.",
    minutes: 5,
    tags: ['Mindset'],
  },
  {
    templateId: 'dream',
    name: 'Dream\nJournal',
    category: 'Daily',
    description:
      'Unlock insights from your dreams and interpret their meaning.',
    minutes: 5,
    timeofDayRange: [4, 10],
    tags: ['Sleep'],
  },
  {
    templateId: 'rose-bud-thorn',
    name: 'Evening\nReflection',
    category: 'Daily',
    description: 'How was your day? Take a moment to reflect.',
    minutes: 5,
    timeofDayRange: [17, 3],
    tags: ['Check-in'],
    weight: -50,
  },
  {
    templateId: 'reframing',
    name: 'Reframing Negative Thoughts',
    category: 'Frameworks',
    description:
      'A CBT exercise to help you improve your relationship with your thoughts.',
    minutes: 10,
    tags: ['CBT'],
  },
  {
    templateId: 'conversation-prep',
    name: 'Conversation\nPrep',
    category: 'Situational',
    description:
      'Prepare for an important conversation and get the outcome you want.',
    minutes: 10,
    tags: ['Relationships'],
  },
  {
    templateId: 'ifs',
    name: 'Internal Family Systems',
    category: 'Frameworks',
    description:
      'Explore and harmonize the multiple facets of your inner self.',
    author: 'David Coates',
    authorImageUrl: '/images/authors/david-coates.jpg',
    authorBio:
      'David Coates is a certified IFS practitioner with over 25 years of experience.',
    minutes: 10,
    tags: ['IFS'],
  },
  {
    templateId: 'conflict',
    name: 'Conflict\nResolution',
    category: 'Situational',
    description:
      'Get support in resolving a conflict with someone in your life.',
    tags: ['Relationships'],
    minutes: 10,
  },
  {
    templateId: 'boundary-setting',
    name: 'Boundary\nSetting',
    category: 'Situational',
    description:
      'Get support in resolving a conflict with someone in your life.',
    tags: ['Relationships'],
    minutes: 10,
  },
  {
    templateId: 'positive-psychology',
    name: 'Positive\nPsychology',
    category: 'Frameworks',
    description: 'Develop a positive outlook on life and foster optimism.',
    author: 'Micha Tomoff',
    authorBio:
      'Micha is a qualified psychologist, systemic coach, trainer and author. He lives in Bonn, Germany where he pursues his passion of recognizing and promoting the strengths and potential of people.',
    authorImageUrl: '/images/authors/micha-tomoff.jpg',
    tags: ['Mindset'],
    minutes: 10,
  },
]
